import React from 'react';

interface XlevenLogoProps {
  theme?: 'light' | 'dark';
  hideText?: boolean;
}

export const XlevenLogo: React.FC<XlevenLogoProps> = ({ theme = 'light', hideText = false }) => (
  <div className={`flex items-center select-none cursor-pointer group ${hideText ? 'w-full h-full' : 'gap-2 md:gap-3'}`}>
    <div className={`relative ${hideText ? 'w-full h-full' : 'w-7 h-7 md:w-9 md:h-9'}`}>
      {/* Background decoration - only show when text is visible to keep the complex brand look */}
      {!hideText && (
        <div className="absolute inset-0 bg-rose-500 rounded-lg md:rounded-xl transform rotate-6 opacity-0 md:opacity-20 hidden md:block"></div>
      )}
      
      {/* Main icon container */}
      <div className={`absolute inset-0 bg-gradient-to-br from-rose-500 to-rose-600 rounded-lg md:rounded-xl flex items-center justify-center transform transition-transform duration-300 ease-out border border-white/10 ${!hideText ? 'md:shadow-lg md:shadow-rose-200' : ''}`}>
         <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${hideText ? 'w-1/2 h-1/2' : 'w-3.5 h-3.5 md:w-[18px] md:h-[18px]'} text-white`}>
            <path d="M20 17H4M4 17L8 13M4 17L8 21" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4 7H20M20 7L16 3M20 7L16 11" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
         </svg>
      </div>
    </div>
    
    {!hideText && (
      <div className="flex items-baseline gap-1 md:gap-2">
          <div className="flex flex-col justify-center">
              <h1 className={`text-lg md:text-2xl font-black tracking-tighter leading-none flex items-center gap-0.5 ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>
                  XLEVEN
                  <div className="w-1 h-1 md:w-1.5 md:h-1.5 rounded-full bg-rose-500 mt-1 md:mt-2 animate-pulse"></div>
              </h1>
          </div>
      </div>
    )}
  </div>
);